import { HEAR_ABOUT_US_OPTIONS } from "@/lib/hearAboutUs";
import { formLabel, formSelect } from "@/lib/form-styles";

export function HearAboutUsField({
  value,
  onChange,
  required = false,
  testId = "hear-about-us",
  label = "How did you hear about us?",
  className = formSelect,
  labelClassName = formLabel,
}) {
  return (
    <div>
      <label htmlFor={testId} className={labelClassName}>
        {label}
        {required ? " *" : ""}
      </label>
      <select
        id={testId}
        data-testid={testId}
        required={required}
        className={className}
        value={value}
        onChange={onChange}
      >
        <option value="">{required ? "Select one…" : "Select one (optional)"}</option>
        {HEAR_ABOUT_US_OPTIONS.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}
